import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import IsNotMaintenanceMode from '../components/IsNotMaintenanceMode';
import Loader from '../components/Loader';
import NotificationsWrapper from '../components/NotificationsWrapper';
import { AuthFormWrapper } from './community/components/auth/AuthFormWrapper';
import { RecoverPasswordScreen } from './community/screens/recover-password';
import { SignInScreen } from './community/screens/sign-in';
import { SignUpScreen } from './community/screens/sign-up';
var CommunityRouter = function () { return (React.createElement(Suspense, { fallback: React.createElement(Loader, null) },
    React.createElement(NotificationsWrapper, null,
        React.createElement(IsNotMaintenanceMode, null,
            React.createElement(Routes, null,
                React.createElement(Route, { path: "/:university_id/:slug/community" },
                    React.createElement(Route, { element: React.createElement(AuthFormWrapper, null) },
                        React.createElement(Route, { index: true, path: "sign-up", element: React.createElement(SignUpScreen, null) }),
                        React.createElement(Route, { path: "sign-in", element: React.createElement(SignInScreen, null) })),
                    React.createElement(Route, { path: "recover-password", element: React.createElement(RecoverPasswordScreen, null) }),
                    React.createElement(Route, { path: "*", element: React.createElement(Navigate, { to: "sign-in" }) }))))))); };
export default CommunityRouter;
